// extracted by mini-css-extract-plugin
export default {"CircleButton":"CircleButton_CircleButton__tK8Ah"};